import { apiFetch } from '@carouselgg/auth/client'

/**
 * Free-agent applications — people asking to join a team an org fields.
 *
 * The app shell only needs the counts, so this is the narrow half of
 * `admin/src/api/recruit.ts`: one call per org gives every team with an open
 * roster and how many people are waiting on it. Naming the individual
 * applicants means a second call per TEAM, which is a fan-out the dashboard
 * should not pay for a side panel — the widget links into the org's recruit
 * screen instead.
 */

export interface OrgTeamWithApps {
  id: string
  name: string
  slug: string
  game_name: string
  /** Applications waiting on a decision. */
  pending_count: number
}

export function listOrgTeamsWithOpenFA(orgID: string): Promise<{ teams: OrgTeamWithApps[] }> {
  return apiFetch<{ teams: OrgTeamWithApps[] }>(`/recruit/${orgID}/org-teams`)
}

/** A captain's invite to the signed-in player, still waiting on an answer. */
export interface MyTeamInvite {
  id: string
  team_name?: string
  team_slug?: string
  org_name?: string
  org_slug?: string
  season_name?: string
  message: string
  /** The deadline to answer, if the captain set one. */
  expires_at?: string | null
}

/** Open invites only: answered and expired ones aren't listed. */
export function listMyTeamInvites(): Promise<{ applications: MyTeamInvite[] }> {
  return apiFetch<{ applications: MyTeamInvite[] }>('/recruit/my-invites')
}

export function answerTeamInvite(id: string, status: 'accepted' | 'declined'): Promise<{ status: string }> {
  return apiFetch<{ status: string }>(`/recruit/invites/${id}/respond`, {
    method: 'PUT',
    body: JSON.stringify({ status }),
  })
}
